<!--Header-->
<div class="flex-header">
  <b class="modal-headerTitle" *ngIf="!editFavorites">Favorites</b>
  <b class="modal-headerTitle" *ngIf="editFavorites">Edit Favorites</b>
</div>
<!--Body-->
<div class="flex-content">
    <favorite-menu [forSelection]="editFavorites"
        [forNavigation]="false"
        [autoSave]="false"
        [defaultPreferences]="isDefaultPreferences"></favorite-menu>
</div>